import { memo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { aiAvatarSelectors } from 'store/features/aiAvatar/selectors'
import AddAvatar from './add-avatar'
import PublicAvatars from './public-avatars'
import AvatarPreview from './avatar-preview'
import PublicAvatarsPresets from './public-avatars/presets-panel'
import * as Styled from './styled'

const AvatarSection: React.FC = () => {
  const hasAvatar = useSelector(aiAvatarSelectors.hasAvatar)
  const isAvatarLoading = useSelector(aiAvatarSelectors.isAvatarLoading)

  const showPreview = hasAvatar || isAvatarLoading

  const sectionRef = useRef<HTMLDivElement>(null)
  const [isPresetsOpen, setIsPresetsOpen] = useState(false)

  return (
    <Styled.AvatarSectionContainer ref={sectionRef}>
      {showPreview ? (
        <AvatarPreview />
      ) : (
        <Styled.CardsRow>
          <AddAvatar onClick={() => setIsPresetsOpen(false)} />
          <PublicAvatars
            onOpen={() => setIsPresetsOpen(true)}
            isActive={isPresetsOpen}
          />
        </Styled.CardsRow>
      )}

      {/* Rendered at the section level (not inside PublicAvatars) so the panel
          stays open after a selection switches the section to preview mode. */}
      <PublicAvatarsPresets
        isOpen={isPresetsOpen}
        anchorEl={sectionRef.current}
        onClose={() => setIsPresetsOpen(false)}
      />
    </Styled.AvatarSectionContainer>
  )
}

export default memo(AvatarSection)
